import { render, staticRenderFns } from "./BookPost.vue?vue&type=template&id=449d5943&scoped=true"
import script from "./BookPost.vue?vue&type=script&lang=js"
export * from "./BookPost.vue?vue&type=script&lang=js"
import style0 from "./BookPost.vue?vue&type=style&index=0&id=449d5943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449d5943",
  null
  
)

export default component.exports